import {useTranslation} from 'react-i18next'
import {MenuItem} from './MenuItem'
import {useAuth} from '../../../../../app/modules/auth'
import {useAppDispatch, useAppSelector} from '../../../../../redux/hooks'
import {UserMsgCount} from '../../../../../redux/Slice/chatSlice'
import {useEffect} from 'react'
import {MenuInnerWithSub} from './MenuInnerWithSub'

export function StudentMenu() {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const {hasPermission} = useAuth()
  const {msgCount} = useAppSelector((state) => state.chat)
  const CountMessages = () => {
    dispatch(UserMsgCount())
  }

  useEffect(() => {
    CountMessages()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [msgCount])
  return (
    <>
      {/* <MenuItem title={t('LABEL.MY_PROFILE')} to='/student/my-profile' /> */}
      <MenuInnerWithSub
        title={t('MENU.DOCUMENT_CENTER')}
        to=''
        menuPlacement='bottom-end'
        menuTrigger='click'
        hasArrow={true}
        fontIcon=''
      >
        <MenuItem
          title={t('LABEL.MY_DOCUMENTS')}
          to='/student/my-documents'
          fontIcon='fa fa-file text-white mx-2'
        />
        <MenuItem
          title={t('LABEL.MY_LETTERS')}
          to='/student/my-letters'
          fontIcon='fa fa-note-sticky text-white mx-2'
        />
        <MenuItem
          title={t('LABEL.MY_NOTES')}
          to='/student/my-notes'
          fontIcon='fa fa-edit text-white mx-2'
        />
      </MenuInnerWithSub>
      {/* academics */}
      {/* <MenuInnerWithSub
        title={t('MENU.ACADEMICS')}
        to=''
        menuPlacement='bottom-end'
        menuTrigger='click'
        hasArrow={true}
        fontIcon=''
      >
        <MenuItem
          title={t('LABEL.MY_COURSES')}
          to='/student/my-courses'
          fontIcon='fa fa-chalkboard text-white mx-2'
        />
        <MenuItem
          title={t('LABEL.MY_TRANSCRIPT')}
          to='/student/my-transcript'
          fontIcon='fa fa-scroll text-white mx-2'
        />
      </MenuInnerWithSub> */}

      <MenuItem title={t('LABEL.MY_FEEDBACK')} to='/student/my-feedback' />
      {/* <MenuItem title={t('LABEL.MY_INVOICES')} to='/student/my-invoices' /> */}
      <MenuItem title={t('LABEL.MY_UMEF')} to='/lec/my-umef' />
      <MenuItem to='/student/my-resource' title={t('LABEL.MY_RESOURCE')} />
      {/* <MenuItem to='/student/meetings' title={t('MEETING.MEETINGS')} /> */}
      {/* <MenuItem to='/student/parent' title={t('PARENT.PARENT_ACCOUNT')} /> */}

      {hasPermission('publications-list') && (
        <MenuItem title={t('MENU.PUBLICATIONS')} to='/student/publications-list' />
      )}

      {/* <MenuItem to='/student/my-videos' title={t('MENU.MY_VIDEO_LIBRARY')} /> */}

      {hasPermission('news-list') && (
        <MenuItem to='/student/my-news' title={t('MENU.NEWS_AND_ANNOUNCEMENTS')} />
      )}
      <MenuItem
        to='/chat/std-chat-room'
        title={
          <span className='position-relative'>
            {t('LABEL.CHAT')}
            <span className='badge badge-circle bg-danger position-absolute top-0 text-white translate-middle'>
              {msgCount}
            </span>
          </span>
        }
      />
    </>
  )
}
